export default "__VITE_ASSET__BM4lNo_X__"